<p-card header="Passkeys" subheader="Dispositivos autorizados para iniciar sesión con rostro, huella o PIN.">
  <p-message
    *ngIf="!supportsPasskeys"
    severity="warn"
    icon="pi pi-exclamation-triangle"
    text="Este navegador no reporta soporte WebAuthn/passkeys."
  ></p-message>

  <div class="overflow-x-auto">
    <p-table [value]="passkeys" dataKey="credentialId" [tableStyle]="{ 'min-width': '56rem' }" styleClass="p-datatable-sm" mbRemovableSort>
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="label">Nombre <p-sortIcon field="label" /></th>
          <th pSortableColumn="createdAt">Agregado <p-sortIcon field="createdAt" /></th>
          <th pSortableColumn="lastUsedAt">Último uso <p-sortIcon field="lastUsedAt" /></th>
          <th pSortableColumn="backedUp">Respaldo <p-sortIcon field="backedUp" /></th>
          <th class="text-right">Acciones</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-passkey>
        <tr>
          <td>
            <div class="flex items-center gap-3">
              <p-avatar icon="pi pi-key" shape="circle"></p-avatar>
              <div>
                <div class="font-semibold">{{ passkey.label }}</div>
                <small>{{ passkey.deviceType === 'multiDevice' ? 'Multidispositivo' : 'Dispositivo único' }}</small>
              </div>
            </div>
          </td>
          <td>{{ formatDate(passkey.createdAt) }}</td>
          <td>{{ formatDate(passkey.lastUsedAt) }}</td>
          <td>
            <p-tag [value]="passkey.backedUp ? 'Respaldado' : 'No respaldado'" [severity]="passkey.backedUp ? 'success' : 'secondary'"></p-tag>
          </td>
          <td class="text-right">
            <div class="flex justify-end gap-2">
              <p-button
                icon="pi pi-pencil"
                variant="text"
                severity="warn"
                size="small"
                [loading]="updatingPasskeyCredentialId === passkey.credentialId"
                pTooltip="Editar"
                tooltipPosition="top"
                (onClick)="openPasskeyNameDialog.emit(passkey)"
              ></p-button>
              <p-button
                icon="pi pi-trash"
                variant="text"
                severity="danger"
                size="small"
                [loading]="deletingCredentialId === passkey.credentialId"
                pTooltip="Eliminar"
                tooltipPosition="top"
                (onClick)="deletePasskey.emit(passkey)"
              ></p-button>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="5">
            <div class="flex flex-col items-center gap-3 py-8 text-center">
              <p-avatar icon="pi pi-key" size="large" shape="circle"></p-avatar>
              <div>
                <div class="font-semibold">Aún no tienes passkeys</div>
                <small>Agrega uno para iniciar sesión con cara, huella o PIN.</small>
              </div>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-end">
      <p-button
        label="Agregar Passkey"
        icon="pi pi-plus-circle"
        iconPos="left"
        severity="primary"
        [loading]="registeringPasskey"
        [disabled]="!supportsPasskeys"
        (onClick)="registerPasskey.emit()"
      ></p-button>
    </div>
  </ng-template>
</p-card>

<p-dialog
  header="Editar nombre del passkey"
  [visible]="showPasskeyNameDialog"
  (visibleChange)="!$event && closePasskeyNameDialog.emit()"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="!updatingPasskeyCredentialId"
  styleClass="w-[min(92vw,32rem)]"
>
  <form [formGroup]="passkeyNameForm" class="flex flex-col gap-3 pt-1" (ngSubmit)="savePasskeyName.emit()">
    <label for="passkeyName" class="font-bold">Nombre del passkey</label>
    <input id="passkeyName" type="text" pInputText formControlName="label" class="w-full" placeholder="Ej: MacBook Pro personal" />
    <small>Usa un nombre que te ayude a reconocer el dispositivo rápidamente.</small>
  </form>
  <ng-template pTemplate="footer">
    <div class="flex flex-wrap items-center justify-between gap-2 w-full">
      <div class="flex gap-2">
        <p-button
          label="Cancelar"
          icon="pi pi-times"
          iconPos="left"
          severity="danger"
          variant="outlined"
          (onClick)="closePasskeyNameDialog.emit()"
          [disabled]="!!updatingPasskeyCredentialId"
        ></p-button>
      </div>

      <div class="flex gap-2">
        <p-button
          label="Guardar"
          icon="pi pi-check"
          iconPos="left"
          severity="success"
          [loading]="!!updatingPasskeyCredentialId"
          [disabled]="passkeyNameForm.invalid"
          (onClick)="savePasskeyName.emit()"
        ></p-button>
      </div>
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  header="Confirmar eliminación de passkey"
  [visible]="showDeletePasskeyDialog"
  (visibleChange)="!$event && closeDeletePasskeyDialog.emit()"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="!deletingCredentialId"
  styleClass="w-[min(92vw,34rem)]"
>
  <form [formGroup]="deletePasskeyForm" class="flex flex-col gap-4 pt-1" (ngSubmit)="confirmDeletePasskey.emit()">
    <p-message severity="error" icon="pi pi-exclamation-triangle">
      Vas a eliminar <strong>{{ deletingPasskeyLabel || 'este passkey' }}</strong
      >. Para continuar, confirma tu contraseña actual.
    </p-message>

    <div class="flex flex-col gap-2">
      <label for="deletePasskeyPassword" class="font-bold">Contraseña actual</label>
      <p-password
        id="deletePasskeyPassword"
        formControlName="currentPassword"
        [feedback]="false"
        [toggleMask]="true"
        inputStyleClass="w-full"
        styleClass="w-full"
      ></p-password>
      <small>Esta validación evita eliminaciones accidentales o no autorizadas.</small>
    </div>
  </form>

  <ng-template pTemplate="footer">
    <div class="flex flex-wrap items-center justify-between gap-2 w-full">
      <div class="flex gap-2">
        <p-button
          label="Cancelar"
          icon="pi pi-times"
          iconPos="left"
          severity="danger"
          variant="outlined"
          (onClick)="closeDeletePasskeyDialog.emit()"
          [disabled]="!!deletingCredentialId"
        ></p-button>
      </div>

      <div class="flex gap-2">
        <p-button
          label="Eliminar passkey"
          icon="pi pi-trash"
          iconPos="left"
          severity="danger"
          [loading]="!!deletingCredentialId"
          [disabled]="deletePasskeyForm.invalid"
          (onClick)="confirmDeletePasskey.emit()"
        ></p-button>
      </div>
    </div>
  </ng-template>
</p-dialog>
